<template>
  <el-dialog
    :title="tagData ? '编辑游戏标签' : '新增游戏标签'"
    :visible="visible"
    width="480px"
    :close-on-click-modal="false"
    class="page-dialog center-dialog"
    @update:visible="$emit('update:visible', $event)"
    @closed="handleDialogClosed"
  >
    <el-form ref="tagFormRef" :model="formData" :rules="formRules" label-width="80px" size="small">
      <el-form-item label="标签名称" prop="title">
        <el-input v-model="formData.title" placeholder="请输入标签名称" maxlength="12" show-word-limit size="small"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number v-model="formData.sort" :controls="false" :min="1" :step="1" placeholder="请输入排序" size="small"></el-input-number>
      </el-form-item>
      <el-form-item label="标签图标">
        <SingleImageUpload v-model="formData.image_url" :size="100" tip="支持 jpg、jpeg、png 格式" />
      </el-form-item>
      <el-form-item label="状态">
        <el-switch v-model="formData.status" :active-value="1" :inactive-value="2"></el-switch>
        <div style="margin-top: 8px; font-size: 12px; color: #999">关闭后，大厅将不会显示该标签</div>
      </el-form-item>
    </el-form>

    <template slot="footer">
      <el-button size="small" @click="handleCancel">取消</el-button>
      <el-button type="primary" size="small" :loading="loading" @click="handleConfirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { createGameCategory, updateGameCategory } from '@/api/gameManage/gameTag.js'
import SingleImageUpload from '@/components/Upload/SingleImageUpload.vue'

export default {
  name: 'ManageGameTagDialog',
  components: { SingleImageUpload },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    tagData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        title: '',
        sort: 1,
        image_url: '',
        status: 1,
      },
      formRules: {
        title: [{ required: true, message: '请输入标签名称', trigger: 'blur' }],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' },
          { type: 'number', message: '排序必须为数字', trigger: 'blur' },
        ],
      },
      loading: false,
    }
  },
  watch: {
    tagData: {
      handler(newVal) {
        if (newVal) {
          this.formData = { ...newVal }
        } else {
          this.resetForm()
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleDialogClosed() {
      this.resetForm()
    },

    resetForm() {
      this.formData = {
        title: '',
        sort: 1,
        image_url: '',
        status: 1,
      }
      if (this.$refs.tagFormRef) {
        this.$refs.tagFormRef.resetFields()
      }
      this.loading = false
    },

    handleCancel() {
      this.$emit('update:visible', false)
    },

    async handleConfirm() {
      try {
        await this.$refs.tagFormRef.validate()
        this.loading = true

        const formData = { ...this.formData }

        if (this.tagData) {
          // 编辑操作
          const response = await updateGameCategory(formData)
          if (response.code === 0) {
            this.$message.success('编辑游戏标签成功')
            this.$emit('save-success')
            this.$emit('update:visible', false)
          } else {
            this.$message.error('编辑游戏标签失败：' + (response.msg || '未知错误'))
          }
        } else {
          // 新增操作
          const response = await createGameCategory(formData)
          if (response.code === 0) {
            this.$message.success('新增游戏标签成功')
            this.$emit('save-success')
            this.$emit('update:visible', false)
          } else {
            this.$message.error('新增游戏标签失败：' + (response.msg || '未知错误'))
          }
        }
      } catch (error) {
        if (error !== 'validate') {
          this.$message.error('操作失败：' + error.message)
          console.error('操作失败:', error)
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped></style>
